import React from "react";
import "../styles/AcademicProjects.css";
import { FaGithub } from "react-icons/fa";
import graph from "../images/academic-projects-img/graph.png";
import COA from "../images/academic-projects-img/COA_PIC.png";
import TacoDB from "../images/academic-projects-img/TacoDB.png";
import Pintos from "../images/academic-projects-img/Pintos_Pic.png";
const GithubIcon = FaGithub as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

interface Project {
  title: string;
  description: string;
  date: string;
  img: string;
  github: string;
}

const academicProjects: Project[] = [
  {
    title: "Graph Algorithms Assignment",
    description: "Implemented Dijkstra’s, Union-Find, and BFS/DFS to solve real-world graph problems like shortest paths, connected components, and network flow.",
    date: "August 2023 - December 2023",
    img: graph,
    github: "https://github.com/srijansa"
  },
  {
    title: "8-bit Processor (Non-Pipelined)",
    description: "Designed a non-pipelined 8-bit processor in Verilog with support for custom ALU operations and tested it on an FPGA board for hardware validation.",
    date: "January 2024 - May 2024",
    img: COA,
    github: "https://github.com/srijansa"
  },
  {
    title: "TacoDB",
    description: "Developed an in-memory SQL database from scratch with slotted pages, B-Tree indexing, join optimization, and query execution.",
    date: "August 2024 - December 2024",
    img: TacoDB,
    github: "https://github.com/srijansa"
  },
  {
    title: "Pintos Operating System",
    description: "Extended Pintos OS by implementing thread scheduling, priority donation, syscall handling, and virtual memory.",
    date: "January 2024 - May 2024",
    img: Pintos,
    github: "https://github.com/srijansa"
  }
];

const AcademicProjects: React.FC = () => {
  return (
    <div className="academic-projects-container">
      <h2 className="section-title">Academic Projects</h2>
      <div className="academic-projects-grid">
        {academicProjects.map((project, index) => (
          <div key={index} className="academic-card">
            <img src={project.img} alt={project.title} className="academic-img" />
            <div className="academic-content">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <div className="project-footer">
                <span className="academic-date">{project.date}</span>
                <a href={project.github} target="_blank" rel="noopener noreferrer">
                  <GithubIcon  className="github-icon" />
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AcademicProjects;
